export default class AsyncUtil
{
	public static sleepAsync(ms:number):Promise<void>
	{
		return new Promise(resolve => setTimeout(resolve, ms));
	}
}